<template>
    <Loading v-if="isLoading" />
    <form v-else @submit.prevent="handleSubmit"
        class="form-horizontal"
        :class="{'schemaform-invalid': hasErrors}"
        enctype="multipart/form-data">
        <SchemaFormGlobalErrors :errors="errors" />
        <div v-if="!isEmpty(schema)">
            <SchemaField
                v-for="(sfield, key) in schema"
                :key="key" :name="key" :schema="sfield"
                :value="form[key]"
                @input="updateKeyPair"
                @change="updateKeyPair"

                :errors="errors[key]"
            />
        </div><!-- :inputChangeEvent="updateKeyPair" -->
        <div v-else>Sorry, this form is not currently available.</div>

        <div class="form-actions">
            <button type="submit" class="btn btn-primary">Save</button>
        </div>
    </form>

</template>

<script>
import Loading from "@/components/Loading";
import SchemaField from "@/components/SchemaField";
import SchemaFormGlobalErrors from "@/components/SchemaFormGlobalErrors";
import SchemaFormMixin from "@/mixins/SchemaFormMixin";

export default {
    name: "SchemaForm",
    mixins: [SchemaFormMixin, ],
    components: {
        Loading,
        SchemaField,
        SchemaFormGlobalErrors,
    }
}
</script>

<style>
.schemaform-invalid {
    background-color: #fff0f0;
}
</style>